import { createUseTranslationMap } from '@vend/react-utilities'
import { TFunction } from '@transifex/react'
import { useCallback } from 'react'
import { STRIPE_ERROR_CODE } from '../helpers/lspayConstants'

let lspayCNPValidationErrorMessages: Record<string, string>
const TContext = 'Lspay CNP inline validation error message'

const buildErrorMessageMap = (t: TFunction) => {
  lspayCNPValidationErrorMessages = {
    [STRIPE_ERROR_CODE.INVALID_NUMBER]: t(
      'Your card number is not a valid credit card number.',
      { _context: TContext }
    ),
    [STRIPE_ERROR_CODE.INVALID_EXPIRY_MONTH]: t(
      'Your card’s expiry month is invalid.',
      { _context: TContext }
    ),
    [STRIPE_ERROR_CODE.INVALID_EXPIRY_YEAR]: t(
      'Your card’s expiry year is invalid.',
      { _context: TContext }
    ),
    [STRIPE_ERROR_CODE.INVALID_CVC]: t(
      'Your card’s security code is invalid.',
      { _context: TContext }
    ),
    [STRIPE_ERROR_CODE.INCORRECT_NUMBER]: t('Your card number is incorrect.', {
      _context: TContext,
    }),
    [STRIPE_ERROR_CODE.INCOMPLETE_NUMBER]: t(
      'Your card number is incomplete.',
      { _context: TContext }
    ),
    [STRIPE_ERROR_CODE.INCOMPLETE_CVC]: t(
      'Your card’s security code is incomplete.',
      { _context: TContext }
    ),
    [STRIPE_ERROR_CODE.INCOMPLETE_EXPIRY]: t(
      'Your card’s expiry date is incomplete.',
      { _context: TContext }
    ),
    [STRIPE_ERROR_CODE.EXPIRED]: t('Your card has expired.', {
      _context: TContext,
    }),
    [STRIPE_ERROR_CODE.INCORRECT_CVC]: t(
      'Your card’s security code is incorrect.',
      { _context: TContext }
    ),
    [STRIPE_ERROR_CODE.INCORRECT_ZIP]: t(
      'Your card’s zip code failed validation.',
      { _context: TContext }
    ),
    [STRIPE_ERROR_CODE.INCOMPLETE_ZIP]: t('Your postal code is incomplete.', {
      _context: TContext,
    }),
    [STRIPE_ERROR_CODE.INVALID_EXPIRY_YEAR_PAST]: t(
      'Your card’s expiry year is in the past.',
      { _context: TContext }
    ),
  }
}

const useErrorMessageMap = createUseTranslationMap(
  buildErrorMessageMap,
  (key: string) => lspayCNPValidationErrorMessages[key]
)

export const useCNPValidationErrorMessages = () => {
  const getErrorMessage = useErrorMessageMap()

  const getErrorMessages = useCallback(
    (errorCode: STRIPE_ERROR_CODE) => {
      return getErrorMessage(errorCode)
    },
    [getErrorMessage]
  )
  return getErrorMessages
}
